import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef, useCallback } from 'react';
export function useHover<T extends HTMLElement = HTMLDivElement>() {
  const [hovered, setHovered] = useState(false);
  const ref = useRef<T>(null);
  const onMouseEnter = useCallback(() => setHovered(true), []);
  const onMouseLeave = useCallback(() => setHovered(false), []);
  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('mouseenter', onMouseEnter);
      ref.current.addEventListener('mouseleave', onMouseLeave);
      return () => {
        ref.current?.removeEventListener('mouseenter', onMouseEnter);
        ref.current?.removeEventListener('mouseleave', onMouseLeave);
      };
    }
    return undefined;
  }, [ref.current]);
  return {
    ref,
    hovered
  };
}
export function useDelayedHover(t0) {
  const $ = _c(12);
  const {
    open,
    close,
    openDelay,
    closeDelay
  } = t0;
  const openTimeout = useRef(-1);
  const closeTimeout = useRef(-1);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      window.clearTimeout(openTimeout.current);
      window.clearTimeout(closeTimeout.current);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const clearTimeouts = t1;
  let t2;
  if ($[1] !== open || $[2] !== openDelay) {
    t2 = () => {
      clearTimeouts();
      if (openDelay === 0) {
        open();
      } else {
        openTimeout.current = window.setTimeout(open, openDelay);
      }
    };
    $[1] = open;
    $[2] = openDelay;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const openDropdown = t2;
  let t3;
  if ($[4] !== close || $[5] !== closeDelay) {
    t3 = () => {
      clearTimeouts();
      if (closeDelay === 0) {
        close();
      } else {
        closeTimeout.current = window.setTimeout(close, closeDelay);
      }
    };
    $[4] = close;
    $[5] = closeDelay;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const closeDropdown = t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => clearTimeouts;
    t5 = [];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== closeDropdown || $[10] !== openDropdown) {
    t6 = {
      openDropdown,
      closeDropdown
    };
    $[9] = closeDropdown;
    $[10] = openDropdown;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}